export const setActiveStepOnBody = (step: string = '') => {
  document.body.dataset.activeStep = step;
};
